import styled from 'styled-components'
import { noTouch } from '@/assets/styles/mixins.css'

const Contact = styled.div`
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 48px minmax(0, 1fr);
  align-items: flex-start;
`

Contact.Icon = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 100%;
  background: var(--color-icon);
  border-radius: 50%;

  &::after {
    content: '';
    width: 0;
    padding-top: 100%;
  }

  svg {
    position: absolute;
    width: 50%;
    height: auto;
  }
`

Contact.Content = styled.dl`
  display: block;
`

Contact.Title = styled.dt`
  padding: 14px 0;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 16px;
  color: var(--color-main);
`

Contact.Desc = styled.dd`
  p {
    margin-bottom: 8px;
    font-size: 16px;
    line-height: 1.6;
    color: var(--color-secondary);
  }

  small {
    font-size: 14px;
  }

  a {
    text-decoration: underline;
    color: var(--color-decor);
    transition: color 0.3s ease-out;
  }

  a[href^='tel'] {
    display: block;
    padding-bottom: 8px;
    font-size: 16px;
    color: var(--color-secondary);
    text-decoration: none;

    ${noTouch()`
      &:hover {
        color: var(--color-decor-hover);
      }
    `}
  }

  a[href^='mailto'] {
    display: block;
    padding-bottom: 8px;
    font-size: 16px;
    text-decoration: underline;
    color: var(--color-decor);

    ${noTouch()`
      &:hover {
        color: var(--color-decor-hover);
      }
    `}
  }
`

export default Contact
